import { useParams, ParamParseKey, resolvePath, generatePath } from 'react-router-dom';
import { AccountManagementRoutes, ManageTenantRoutes } from './routes';
import { withRoot } from './with-root';

export const useManageTenantGeneratePath = () => {
    const { externalTenantId, externalPartnerId } =
        useParams<ParamParseKey<typeof AccountManagementRoutes.manageTenant>>();

    const generateBasePath = (route: keyof typeof ManageTenantRoutes): string => {
        return generatePath(
            resolvePath(ManageTenantRoutes[route], AccountManagementRoutes.manageTenant).pathname,
            {
                externalPartnerId: externalPartnerId!,
                externalTenantId: externalTenantId!,
            },
        );
    };

    const generateManageTenantPath = (route: keyof typeof ManageTenantRoutes): string => {
        return withRoot(generateBasePath(route));
    };

    const generateManageTenantPathRelative = (route: keyof typeof ManageTenantRoutes): string => {
        return generateBasePath(route);
    };

    return { generateManageTenantPath, generateManageTenantPathRelative };
};
